import React, { Component } from 'react';

import PropTypes from 'prop-types';

import BaseLoading from './BaseLoading';
import RelativeLoading from './RelativeLoading';

export default class Loading extends Component {
  constructor(props) {
    super(props);
  }

  static propTypes = {
    relative: PropTypes.bool,
  };

  static defaultProps = {
    text: <span>Loading ...</span>,
    spinnerSize: 'xlarge',
    fontSize: 'xx-large',
    relative: false,
  };

  render() {
    return (
      <div
        style={{
          height: '100%',
          width: '100%',
        }}
      >
        {this.props.relative ? (
          <RelativeLoading {...this.props} />
        ) : (
          <BaseLoading {...this.props} />
        )}
      </div>
    );
  }
}
